import { useEffect } from 'react'

import { refreshSession } from '@/lib/httpClient'
import { useAuthStore } from '@/stores/authStore'

/** Renova o access token ~1 min antes de expirar, para nenhuma tela ver um 401. */
const SKEW_MS = 60_000
const MIN_DELAY_MS = 5_000

export function useAccessTokenRefresher(): void {
  const status = useAuthStore((state) => state.status)
  const expiresAt = useAuthStore((state) => state.accessTokenExpiresAt)

  useEffect(() => {
    if (status !== 'authenticated' || !expiresAt) return

    const delay = Math.max(expiresAt - Date.now() - SKEW_MS, MIN_DELAY_MS)
    const id = setTimeout(() => {
      // Erros são tratados dentro de refreshSession (limpa a sessão em falha).
      void refreshSession().catch(() => {})
    }, delay)

    return () => clearTimeout(id)
  }, [status, expiresAt])
}
